<template>
  <b-tabs>
    <b-tab>
      <template slot="title">
        <i class='icon-list'></i>
      </template>
      <b-list-group class="list-group-accent">
        <b-list-group-item class="list-group-item-accent-secondary bg-light text-center font-weight-bold text-muted text-uppercase small">
          Today
        </b-list-group-item>
        <b-list-group-item href="#" class="list-group-item-accent-warning list-group-item-divider">
          <div>UNOCHA Assessment Mission</div>
          <div>
            <small class="text-muted mr-3">
              <i class="icon-calendar"></i>&nbsp;&nbsp;20-22 April 2018
            </small>
          </div>
          <div>
            <small class="text-muted">
              <i class="icon-location-pin"></i>&nbsp;&nbsp;Sana'a-Hodaydah
            </small>
          </div>
        </b-list-group-item>
        <b-list-group-item href="#" class="list-group-item-accent-info">
          <div>UNOCHA Distribuition of Aid</div>
          <div>
            <small class="text-muted mr-3"><i class="icon-calendar"></i>&nbsp;&nbsp;20-26 May 2018</small>
          </div>
          <div>
            <small class="text-muted"><i class="icon-location-pin"></i>&nbsp;&nbsp;Sana'a</small>
          </div>
        </b-list-group-item>
        <hr class="transparent mx-3 my-0">
      </b-list-group>
    </b-tab>
  </b-tabs>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue'
export default {
  name: 'DafaultAside',
  components: {
    cSwitch
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/AsidePanel.vue